import React from 'react';
import { TextItem } from '../components';
import { ActionsColumn } from '../columns';
import { Cell } from '../cells';

/**
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function HeaderActionsCell(props: React.HTMLProps<HTMLTableHeaderCellElement>) {
  return (
    <ActionsColumn isHeader={true} {...props}>
      <Cell className="flex-centering">
        <TextItem>Actions</TextItem>
      </Cell>
    </ActionsColumn>
  );
}
